import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Button, Row, Tooltip, Form, Col, Pagination, Collapse, Rate} from 'antd';
import {Field, reduxForm} from "redux-form";

import TextField from '../formFields/TextField';
import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";
import DatePickerField from "../formFields/DatePickerField";
import _ from "lodash"
import moment from "jalali-moment";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'5%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width:"10%"
    },
    {
        title: 'کد سفارش',
        dataIndex: 'order_system_code',
        sorter: (a, b) => a.order_system_code - b.order_system_code,
        width:"10%"
    },
    {
        title: 'تاریخ استعلام',
        dataIndex: 'creation_date',
        width:"10%"
    },
    {
        title: 'نام تکنسین',
        dataIndex: 'technician_by',
        width:"10%"
    },
    {
        title: 'نام اپراتور',
        dataIndex: 'operated_by',
        width:"10%"
    },
    {
        title: 'قیمت سیستمی',
        dataIndex: 'system_price',
        width:"10%"
    },
    {
        title: 'محصول گارانتی دار',
        dataIndex: 'guarantee_table',
        width:"10%"
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width:"10%"
    },
  ];


class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:false,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            filter:[]
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        this.props.getList();
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];

        if(list && list.lists) {
console.log(list.lists)
            for (let i = 0; i < list.lists.length; i++) {

                let guarantee_table = []
                if(list.lists[i].guarantee_table && list.lists[i].guarantee_table.length > 0)
                    list.lists[i].guarantee_table.map((item, index) => {
                        guarantee_table.push(item.title)
                    })
                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    order_system_code: list.lists[i].order.system_code,
                    creation_date: list.lists[i].created_at ? moment(list.lists[i].created_at).format('H:m jYYYY/jM/jD') : '',
                    technician_by: list.lists[i].technician_by ? list.lists[i].technician_by.name+' '+list.lists[i].technician_by.family : '',
                    operated_by: list.lists[i].operated_by ? list.lists[i].operated_by.name+' '+list.lists[i].operated_by.family : 'هنوز توسط اپراتور تایید نشده است',
                    system_price: list.lists[i].system_price,
                    guarantee_table: _.trimEnd(guarantee_table, " , "),
                    action: <span>
                        {list.lists[i].has_checked === false ?
                            <Tooltip placement="top" title="بررسی">
                                <a href={"#/guarantee/inquiry/"+list.lists[i]._id} className="listBtn"><Icon type="file-search" /></a>
                            </Tooltip>
                        : null}
                        </span>
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    async __onChangeCounter(current, pageSize) {
        this.setState({size:pageSize});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList();
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const { searchBoxHidden,pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={20}>
                        <Divider orientation="left">لیست استعلام ها</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={4} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="title"
                                    component={TextField}
                                    type="text"
                                    placeholder="عنوان"
                                    onBlur={(title) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,title:title}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                 <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } {...this.state} pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : 10)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions = {['10','20','50','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default List = reduxForm({
    form: 'list'
})(List)
